import { render, staticRenderFns } from "./contentDialog.vue?vue&type=template&id=4627dfb9&scoped=true&"
import script from "./contentDialog.vue?vue&type=script&lang=js&"
export * from "./contentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4627dfb9",
  null
  
)

export default component.exports